export const UPDATE_APP_SETTINGS_REQUEST = 'appSettings/UPDATE_REQUEST';
export const UPDATE_APP_SETTINGS_SUCCESS = 'appSettings/UPDATE_SUCCESS';
export const UPDATE_APP_SETTINGS_FAILURE = 'appSettings/UPDATE_FAILURE';
export const UPDATE_APP_SETTINGS_ON_STORE = 'appSettings/UPDATE_ON_STORE';

export const updateAppSettingsRequest = (payload, externalId) => ({
  type: UPDATE_APP_SETTINGS_REQUEST,
  payload,
  meta: {
    bi: {
      externalId,
    },
  },
});
export const updateAppSettingsSuccess = payload => ({
  type: UPDATE_APP_SETTINGS_SUCCESS,
  payload,
});
export const updateAppSettingsFailure = () => ({
  type: UPDATE_APP_SETTINGS_FAILURE,
});

// eslint-disable-next-line max-params
export const updateAppSettings = (compId, externalId, viewMode, settings, isMainPage = false) => (dispatch, getState, { request }) => {
  dispatch(updateAppSettingsRequest(settings, externalId));
  const newSettings = getState().appSettings;

  return request
    .post(`/_api/settings?compId=${compId}&externalId=${externalId}&viewMode=${viewMode}&isMainPage=${isMainPage}`, newSettings)
    .then(responseData => dispatch(updateAppSettingsSuccess(responseData)))
    .catch(() => dispatch(updateAppSettingsFailure()));
};

//onlly perform update localy - do not change the settings on server - this is used in wix change style in the editor (before save/publish)
export const updateAppSettingsOnStore = payload => ({
  type: UPDATE_APP_SETTINGS_ON_STORE,
  payload,
});

export const updateBooleanValueOnStore = (key, value) =>
  updateAppSettingsOnStore({
    style: {
      booleans: {
        [key]: value,
      },
    },
  });



// WEBPACK FOOTER //
// ./app/actions/update-app-settings.js